import Modal from 'app/components/layouts/Modals/Index';
import { useTranslation } from 'next-i18next';

const ModalReadyTest = ({ isOpen, onClose, onConfirm}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('tests.alert_click_ready')}
      confirmButtonText={t('tests.ready')}
      cancelButtonText={t('commons.cancel')}
      showCancelButton={true}
      show={isOpen}
      onClose={onClose}
      onConfirm={() => onConfirm()}
    >
    </Modal>
  )
}

export default ModalReadyTest
